module.exports = __webpack_public_path__ + "static/media/8.d203362b.jpg";